// import update from "immutability-helper";
// import uuid from "uuid/v4";
import {
  SET_PAGE_CONTENT,
  UPDATE_BREADCRUMBS,
  UPDATE_PROFILE_PERMISSION,
  SET_ACCESS_LOGIC,
  SET_FIELD_ACCESS,
  SET_ACCESS_USER_LOGIC,
  SET_BUTTON_ACCESS,
  UPDATE_EMAIL_ACCESS_FIELD
} from "../actionTypes/ProfileActionTypes";

const initialState = {
  page: "ProfileList",
  breadCrumbs: {},
  profileDetails:{}
};

const ProfileReducer = (state = initialState, action) => {
  let object = null;
  switch (action.type) {
    case SET_PAGE_CONTENT:
      state.page = action.payload.element;
      state.profileDetails = action.payload.profileDetails;
      console.log('yesssss'+ JSON.stringify(state.profileDetails))
    return {
        ...state,
        page:state.page,
        profileDetails:{...state.profileDetails}
      };
    case UPDATE_PROFILE_PERMISSION:
      object = action.payload.object;
      let selectedCount = 0;
      //Access count (View,Edit, Create and Delete)
      state.profileDetails.windows[object.sectionIndex].window_authorities.forEach((item,index)=>{
        if(item.authority_name.toLowerCase()!=='view' && (item.is_selected==='true' || item.is_selected===true || object.isChecked===true || object.isChecked==='true')){ 
          selectedCount++;
          // return item;
        }
      });
      //Checked selected Access and Auto select View Access based on Logic
      state.profileDetails.windows[object.sectionIndex].window_authorities.forEach((item,index)=>{
        if(item.authority_name.toLowerCase()===object.authorityName){
            state.profileDetails.windows[object.sectionIndex].window_authorities[index].is_selected = object.isChecked;
        }
        if(item.authority_name.toLowerCase()==='view'){
            state.profileDetails.windows[object.sectionIndex].window_authorities[index].is_selected  = (selectedCount>0)? true:false;
          }
          return item;
      })
      return {
          ...state,
          page:state.page,
          profileDetails:{...state.profileDetails}
        }; 
      case SET_FIELD_ACCESS:
        object = action.payload.object;
        state.profileDetails.windows[object.sectionIndex].fields[object.fieldIndex].field_permission.access_mode =object.accessMode; 
        return {
          ...state,
          page:state.page,
          profileDetails:{...state.profileDetails}
        };
      case SET_BUTTON_ACCESS:
          object = action.payload.object;
          state.profileDetails.windows[object.sectionIndex].action_components[object.buttonIndex].is_permitted = object.accessMode; 
          return {
            ...state,
            page:state.page,
            profileDetails:{...state.profileDetails}
          };  
      case SET_ACCESS_LOGIC:
         object = action.payload.object;
        // console.log(JSON.stringify(object.selectedCount) + 'object.selectedCount');
        state.profileDetails.windows[object.sectionIndex].window_authorities.forEach((item,index)=>{
          
          state.profileDetails.windows[object.sectionIndex].window_authorities[index].is_selected = (object.selectedCount>0)? false : 'true';
        })
          return {
            ...state,
            page:state.page,
            profileDetails:{...state.profileDetails}
          };
      case SET_ACCESS_USER_LOGIC:
        object = action.payload.object;
        // console.log(JSON.stringify(object.selectedCount) + 'object.selectedCount');                 
        if((object.sectionTitle==='Manage Users' || object.sectionTitle==='Manange Users') && (object.selectedCount>0)){ // click Manage Users                       
            state.profileDetails.user_settings.forEach((userpermission,index)=>{
              if(userpermission.title ==='Manage Users' || userpermission.title ==='Manage Profiles' || userpermission.title==='Manage Roles'){
                state.profileDetails.user_settings[index].is_manage = (object.selectedCount>0)? false : 'true';
              }
            })
        }else{
          // check Manage Users condition
          let isUSer = '';
          state.profileDetails.user_settings.forEach((userpermission,index)=>{
            if(userpermission.title ==='Manage Users'){
              isUSer = userpermission.is_manage;
            }
          })          
          if(isUSer===false){          
            state.profileDetails.user_settings.forEach((userpermission,index)=>{
              if(userpermission.title ==='Manage Users' || userpermission.title ==='Manage Profiles' || userpermission.title==='Manage Roles'){
                state.profileDetails.user_settings[index].is_manage = (object.selectedCount>0)? false : 'true';
              }
            })
          }
          else{            
            state.profileDetails.user_settings[object.sectionIndex].is_manage = (object.selectedCount>0)? false : 'true';
          }
        }                                          
        return {
          ...state,
          page:state.page,
          profileDetails:{...state.profileDetails}
        };    
    case UPDATE_BREADCRUMBS:
      state.breadCrumbs = {...action.payload.element.breadCrumbs};
      state.page = "ProfilePermission";
      console.log(initialState);
      return{
        ...state
      }
    case UPDATE_EMAIL_ACCESS_FIELD:
      state.profileDetails.email_config_permissions[action.payload.id].access_type = action.payload.value;
      console.log(state.profileDetails.email_config_permissions);
      return{
        ...state,
        page:state.page,
        profileDetails:{...state.profileDetails}
      }  
    default:
      return state;
  }
};
export default ProfileReducer;
